<template>
  <el-form-item
    :label="name"
    class="ik-select"
    :prop="code"
  >
    <el-tooltip :disabled="tips==='' || tips===null || tips===undefined" class="item" effect="dark" :content="tips" placement="top">
      <el-select
        v-model="val"
        :class="{'require':getRequire && isNull()}"
        size="small"
        :disabled="disabled"
        placeholder=" -- 请选择 -- "
        :clearable="true"
        @change="change"
      >
        <el-option
          v-for="item in options"
          :key="item[keyField]"
          :label="item[valueField]"
          :value="item[keyField]"
        />
      </el-select>
    </el-tooltip>
    <el-tooltip v-if="errorSign" class="right" effect="dark" :content="message" placement="top">
      <div>
        <i class="el-icon-warning" style="color:red;" />
      </div>
    </el-tooltip>
  </el-form-item>
</template>

<script>
import { verify } from '@/utils/ik/verify/verify.js'
export default {
  name: 'IkFormSelect',
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'change'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: ''
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    // 取值监听
    value: {
      handler(value, oldValue) {
        if (value !== null || value !== '' || this.val !== undefined) {
          this.val = value
        } else {
          this.val = this.defaultValue
        }
        this.change(this.val)
      },
      immediate: true
    }
  },
  mounted() {
  },
  // 如果value为空，取默认值
  created() {
    this.change(this.val)
  },
  methods: {
    change(value) {
      // 取值验证
      this.message = verify(value, this.rules)
      if (this.message !== null) {
        this.errorSign = true
      } else {
        this.errorSign = false
      }
      // 空值验证
      if (this.getRequire && this.isNull()) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      // v-model实现触发方法
      this.$emit('change', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    }
  }
}
</script>

<style scoped>
::v-deep.require > .el-input > .el-input__inner {
  border: red 1px solid;
}
</style>
<style lang="scss" scoped >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-select {
  width: 100%;
}
.ik-select{
  ::v-deep.el-form-item__label {
    // width: 210px!important;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep.el-form-item__content {
    width: calc(100% - 180px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.item{width:calc(100% - 30px)}
</style>
